import React from 'react';
import {Button, Space} from 'antd';
import UserRoleSelect from '../../components/pages/TeamPage/tabComponents/UserRoleSelect';
import UserDetails from '../../components/UserDetails';
import {userStatusesConstants, userRolesConstants, userGroupConstants} from '../../constants';
import {objectHelpers} from './object.helpers';
import {textHelpers} from './text.helpers';

const {ACTIVE, DISABLED, EXTERNAL, PENDING} = userStatusesConstants;
const {ADMIN, BOOKKEEPER, SUPPORT, USER} = userRolesConstants;

const gObjProp = objectHelpers.getObjProp;

const userRoles = {
  [ADMIN]: {
    key: 'userRoles.admin',
    color: '#52C41A'
  },
  [BOOKKEEPER]: {
    key: 'userRoles.bookkeeper',
    color: '#D9D9D9',
  },
  [USER]: {
    key: 'userRoles.user',
    color: '#D9D9D9'
  },
  [SUPPORT]: {
    key: 'userRoles.support',
    color: '#D9D9D9'
  },
};


export const teamsHelpers = {
  getEmployeeDetails: (employee) => {
    if (employee && typeof employee === 'object') {
      return <UserDetails user={employee} />;
    } else {
      return null;
    }
  },
  getUserGroupLabel: (employee, t) => {
    const userGroup = {
      [userStatusesConstants.ACTIVE]: userGroupConstants.ACTIVE,
      [userStatusesConstants.PENDING]: userGroupConstants.EXTERNAL,
      [userStatusesConstants.EXTERNAL]: userGroupConstants.EXTERNAL,
      [userStatusesConstants.DISABLED]: userGroupConstants.DISABLED,
    }[employee?.account_status];
    return userGroup !== undefined ? t(`main:userGroups.${userGroup}`) : '';
  },
  getRole: ({employee, onChange}) => {
    if (employee && typeof employee === 'object') {
      return (
        <UserRoleSelect
          defaultValue={employee.role}
          email={employee.email}
          onClick={(e) => e.stopPropagation()}
          onChange={(value) => onChange?.(value)}
        />
      )
    } else {
      return null;
    }
  },
  getActions: ({employee, editorEmail, t, onClick, isEditorSupport}) => {
    if (employee && typeof employee === 'object') {
      const status = gObjProp(employee, 'account_status');
      const email = gObjProp(employee, 'email');
      const role = gObjProp(employee, 'role');
      const isSupportRole = role === SUPPORT;
      if (email === editorEmail) return ;

      const buttons = {
        [ACTIVE]: !isEditorSupport && (
          <Button
            danger
            onClick={(e) => onClick({e, action: 'disable', employee})}
            type='text'
          >
            {t('main:disable')}
          </Button>
        ),
        [DISABLED]: !isEditorSupport && (
          <Button
            danger
            onClick={(e) => onClick({e, action: 'enable', employee})}
            type='text'
          >
            {t('main:enable')}
          </Button>
        ),
        [EXTERNAL]: (
          <Button
            className='primary'
            onClick={(e) => onClick({e, action: 'invite', employee})}
            type='text'
          >
            {t('main:invite')}
          </Button>
        ),
        [PENDING]: (
          <>
            <Button
              className='primary'
              onClick={(e) => onClick({e, action: 'resend-invite', employee})}
              type='text'
            >
              {t('teams:resendInvite')}
            </Button>
            {!isEditorSupport && (
              <Button
                danger
                onClick={(e) => onClick({e, action: 'delete', employee})}
                type='text'
              >
                {t('main:cancel')}
              </Button>
            )}
          </>
        ),
      };
      // hide actions is editor has support role && edited user has support role as well
      if (isSupportRole && !isEditorSupport && [ACTIVE, DISABLED].includes(status)) return ;
      return buttons.hasOwnProperty(status) ? (
        <Space className='actions'>
          {buttons[status]}
        </Space>
      ) : null;
    } else {
      return null;
    }
  },
  getUserRole: (role) => objectHelpers.getStatus(role, userRoles),
  getConfirmModalProps: ({t, action, employee, ...rest}) => ({
    cancelButtonProps: {size: 'large', className: 'green-btn-outlined'},
    cancelText: t('no'),
    icon: null,
    okButtonProps: {size: 'large', type: 'primary'},
    okText: t('yes'),
    title: t('teams:modal.actionModal.title', {action, name: employee?.full_name || employee?.email}),
    ...rest
  }),
  getReInvitedUserData: (employee) => {
    let invitations = employee.invitation_attempts;
    invitations = invitations ? JSON.parse(invitations.replace(/'/g, '"')) : [];
    invitations.push(`${Math.floor(Date.now() / 1000)}`)
    return {
      ...employee,
      account_status: userStatusesConstants.PENDING,
      invitation_attempts: JSON.stringify(invitations)
    }
  },
  getCompanyAddress: (data) => {
    const {address, zip_code: zip, city, country} = data;
    const getProp = (prop, useComma = false) => prop ? `${prop}${useComma ? ',' : ''}` : '';
    const countryName = textHelpers.getCapitalized(getProp(country));
    return `${getProp(address, true)} ${getProp(zip)} ${getProp(city, true)} ${countryName}`;
  },
  isAdmin: (userRole) => [ADMIN, BOOKKEEPER, SUPPORT].includes(userRole),
  isSupport: (userRole) => [BOOKKEEPER, SUPPORT].includes(userRole),
}
